import { Button, Checkbox, ConfigProvider, Dropdown, Flex, Form, Input, InputRef, Select, Space, Table, TableColumnType, Tabs, Tooltip, Typography, theme } from "antd";
import { ColumnConfigItemType, SelectUserParams, UserData } from "../../../../utils/datatype";
import { DatePicker } from 'antd';
import { useTypedDispatch, useTypedSelector } from "../../../../hooks/store.hook";
import { useOldMapConvertToNew } from "../../../../hooks/oldMapConvertToNew.hook";
import { useQuery } from "@tanstack/react-query";
import React, { useEffect, useMemo, useRef, useState } from "react";
import dayjs from 'dayjs';
import { useForm } from "antd/es/form/Form";
import { _message } from "../../../../components/message";
import { v4 as uuidv4 } from 'uuid';
import GoogleModal from "../../components/google.modal";
import SnapModal from '@/components/modal/snap.modal';
import FacebookModal from "../../components/facebook.modal";
import BingModal from "../../components/bing.modal";
import AllModal from "../../components/all.modal";
import { MODAL_TYPE } from "../../../../store/reducers/modalSlice";
import { findRoi, selectUser } from "../../service";
import zhCN from 'antd/es/locale/zh_CN';
import { FieldData } from "rc-field-form/es/interface";
import { exportSnapCsvData } from '@/modules/middle_off/service';
import { SearchOutlined, UnorderedListOutlined, ReloadOutlined } from "@ant-design/icons";
import { TableRef } from "antd/es/table";
import { useDebounceFn } from "ahooks";
import { RoiData } from "../../utils/data.type";
import { downloadCSV } from '@/utils/datahandle';
import { ROIAPI } from "../../env";
import { FindRoiParams } from "../../utils/data.type";
import "./index.scss";

const { useToken } = theme; 
const { Text } = Typography;

const { RangePicker } = DatePicker;

const columnConfig : Array<ColumnConfigItemType> = [
    {
        dataIndex: 'subAccountId',
        title: 'Account ID',
        className: 'td-column',
        isShow: true,
        width: 140,
        canSearch: true,
        sorter: {
            compare: (a: any, b: any) => a.subAccountId.localeCompare(b.subAccountId),
        }
    },
    {
        dataIndex: 'camName',
        title: 'Ad Name',
        className: 'td-column',
        isShow: true,
        width: 140,
        canSearch: true,
        sorter: {
            compare: (a: any, b: any) => a.camName.localeCompare(b.camName),
        }
    },
    {
        dataIndex: 'adSetName',
        title: 'Group Name',
        className: 'td-column',
        isShow: true,
        width: 140,
        canSearch: true,
        sorter: {
            compare: (a: any, b: any) => a.groupName.localeCompare(b.groupName),
        },
        render: (value: string) => {
            return <span>{value || '-'}</span>
        }
    },
    {
        dataIndex: 'country',
        title: 'Country',
        className: 'td-column',
        isShow: true,
        width: 95,
        sorter: {
            compare: (a: any, b: any) => a.country.localeCompare(b.country),
        }
    },
    {
        dataIndex: 'labelUrl',
        title: 'URL Channel',
        className: 'td-column',
        isShow: true,
        width: 150,
        canSearch: true,
        sorter: {
            compare: (a: any, b: any) => a.labelUrl.localeCompare(b.labelUrl),
        }
    },
    {
        dataIndex: 'queryDate',
        title: 'Query Date',
        className: 'td-column',
        isShow: true,
        width: 120,
        sorter: {
            compare: (a: any, b: any) => a.queryDate - b.queryDate,
        }
    },
    {
        dataIndex: 'currencyCode',
        title: 'Currency Code',
        className: 'td-column',
        isShow: true,
        width: 80
    },
    {
        dataIndex: 'adsCostMicros',
        title: 'Cost',
        className: 'td-column',
        isShow: true,
        width: 90,
        canSearch: true,
        sorter: {
            compare: (a: any, b: any) => a.adsCostMicros - b.adsCostMicros,
        }
    },
    {
        dataIndex: 'adsenseCostMicros',
        title: 'Adsense Revenue',
        className: 'td-column',
        isShow: true,
        width: 120,
        canSearch: true,
        sorter: {
            compare: (a: any, b: any) => a.adsenseCostMicros - b.adsenseCostMicros,
        }
    },
    {
        dataIndex: 'roi',
        title: 'ROI',
        className: 'td-column',
        isShow: true,
        width: 90,
        render: (text: string) => {
            return <span>{text}</span>;
        },
        sorter: {
            compare: (a: any, b: any) => a.roi.replace('%', '') - b.roi.replace('%', '')
        },
        canSearch: true
    },
    {
        dataIndex: 'adsAvgCpc',
        title: 'Avg CPC',
        className: 'td-column',
        isShow: true,
        width: 120,
        render: (text: string) => {
            return <span>{text.toString() === '-1' ? '-' : text}</span>;
        },
        sorter: {
            compare: (a: any, b: any) => a.adsAvgCpc - b.adsAvgCpc,
        }
    },
    {
        dataIndex: 'adsAvgCost',
        title: 'Avg CPA',
        className: 'td-column',
        isShow: true,
        width: 120,
        render: (text: string) => {
            return <span>{text.toString() === '-1' ? '-' : text}</span>;
        },
        sorter: {
            compare: (a: any, b: any) => a.adsAvgCost - b.adsAvgCost,
        }
    },
    {
        dataIndex: 'costPerClick',
        title: 'Adsense CPC',
        className: 'td-column',
        isShow: true,
        width: 80,
        sorter: {
            compare: (a: any, b: any) => a.costPerClick - b.costPerClick,
        }
    },
    {
        dataIndex: 'adManagerEcpm',
        title: 'Ad Manager Ecpm',
        width: 100,
        className: 'td-column',
        isShow: true,
        render: (value: number) => value || 0,
        sorter: {
            compare: (a: any, b: any) => a.adManagerEcpm - b.adManagerEcpm,
        }
    }
];

const IncomeOptions = [
    {
        label: '否',
        value: '0'
    },
    {
        label: '是',
        value: '1'
    }
];

const columnConfigFN = (platform: string) => {
    if (['snap', 'bing'].includes(platform)) {
        return columnConfig.filter(column => column.dataIndex !== 'adManagerEcpm');
    }
    return columnConfig;
}

function RoiBoardHeader({ userData, platform, setColumnFields, findRoiStatus, data } : { userData: UserData, platform: 'google' | 'facebook' | string, setColumnFields: React.Dispatch<React.SetStateAction<string[]>>, findRoiStatus: { isError: boolean, isSuccess: boolean, isLoading: boolean }, data: any }) {
    const dispatch = useTypedDispatch();
    const columnConfig = columnConfigFN(platform);
    const [ form ] = useForm();
    // * 获取用户查询参数缓存
    const { users } = useTypedSelector(state => state.roiReducer);
    const { domains, countrys, atn } = userData;
    const [ currentDomain , setCurrentDomain ] = useState<string>();

    const { isLoading, isSuccess, isError } = findRoiStatus;
    const { token } = useToken();

    // * 获取当前用户查询缓存并转为form initial value
    const formInitialValues = useMemo(() => {
        let params!: FindRoiParams;
        switch(platform){
            case 'snap':
                params = users[atn]?.snapparams;
                break;
            case 'facebook':
                params = users[atn]?.facebookparams;
                break;
            case 'bing':
                params = users[atn]?.bingparams;
                break;
            default:
                params = users[atn]?.googleparams;
                break;
        }
        if(users[atn] && params){
            setCurrentDomain(params?.labelUrl);
            return platform === 'facebook' ? {
                currencyCode: params?.currencyCode,
                labelUrl: params?.labelUrl,
                channel: params?.channel,
                date: [dayjs(params?.date), dayjs(params?.endDate)],
                country: params?.country,
                isShowOnlyIncome:  params?.isShowOnlyIncome
            } : {
                currencyCode: params?.currencyCode,
                labelUrl: params?.labelUrl,
                channel: params?.channel,
                date: [dayjs(params?.date), dayjs(params?.endDate)],
                country: params?.country
            };
        }else{
            setCurrentDomain(domains[0]?.domain);
            return {
                labelUrl: domains[0]?.domain,
                currencyCode: 'HKD',
                country: undefined,
                date: [dayjs(), dayjs()],
                isShowOnlyIncome: undefined
            }
        }
    }, [atn]) 


    const countries = useMemo( () => Object.keys(countrys).map(key => {
        return {
            label: countrys[key],
            value: key
        }
    }), [countrys]);


    const filter = (inputValue: string, path: any) => {
        const isArray = Array.isArray(path);
        switch (isArray) {
            case true:
                const inputs = inputValue.split('/');
                return inputs.length > 1  ? path.some((option: { label: string, value: string }) => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1) : path.some((option: { label: string, value: string }) => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1);
            default:
                return path.label?.toLowerCase().indexOf(inputValue.toLowerCase()) > -1;
        }
    }

    // * 设置查询参数
    const setQueryParams = () => {
        const values = form.getFieldsValue();
        values['channel'] = values['channel'] || '';
        values['endDate'] = values['date'][1].format('YYYYMMDD');
        values['date'] = values['date'][0].format('YYYYMMDD');
        values['country'] = values['country'] ? values['country'] : '';
        if (platform === 'facebook') {
            values['isShowOnlyIncome'] = values['isShowOnlyIncome'] ? values['isShowOnlyIncome'] : '0';
        }
        const roiParams = {...values, uid: atn , dataType: 'day'};
        return roiParams;
    }


    // * 查询
    const query = async (event: any) => {
        try{
            await form.validateFields();
            const roiParams = setQueryParams();
            dispatch({ type: "roi/setUserQuery", payload: { atn: atn, value: { params: roiParams, platform: platform } } });
            dispatch({ type: "roi/switchAutoQuery", payload: true });
            dispatch({ type: "roi/setRefetch", payload: uuidv4() });
        }catch(err: any) {
            if(err.errorFields){
                err.errorFields.forEach((v:any) => {
                    _message.error(v.errors.join(','))
                })
            }
        }
    }

    const exportSnapHandler = async (params: any) => {
        const csvData = await exportSnapCsvData(params);
        downloadCSV(csvData, dayjs().format('YYYYMMDDHHmmss'));
    };

    // * 导出csv文件
    const exportHandler = async () => {
        try{
            await form.validateFields();
            const roiParams = setQueryParams();
            if (platform === 'snap') {
                exportSnapHandler(roiParams);
            } else {
                let url;
                switch(platform){
                    case 'bing':
                        url = 'googleroi/bing/csv/export';
                        break;
                    case 'facebook':
                        url = '/googleroi/fb/csv/export';
                        break;
                    default:
                        url = '/googleroi/csv/export';
                        break;
                }
                const queryString = new URLSearchParams(roiParams).toString();
                window.location.href = ROIAPI + url + '?' + queryString;
            }
        }catch(err: any) {
            if(err.errorFields){
                err.errorFields.forEach((v:any) => {
                    _message.error(v.errors.join(','))
                })
            }
        }
    }

    const onSelect = (value: string) => {
        setCurrentDomain(value);
        form.setFieldValue('channel', undefined);
    }

    const onColumnChange = (changeFields: FieldData[], allFields: FieldData[]) => {
        const fields = (allFields.filter(item => item.value)).map(item => item.name[0]);
        setColumnFields(fields);
        localStorage.setItem('columnCache', JSON.stringify(fields));
    }


    useEffect(() => {
        form.resetFields();
        if(form.getFieldValue('currencyCode') || form.getFieldValue('labelUrl')){
            const roiParams = setQueryParams();
            dispatch({ type: "roi/setUserQuery", payload: { atn: atn, value: { params: roiParams, platform: platform } } });
            dispatch({ type: "roi/switchAutoQuery", payload: true });
        }
    }, [formInitialValues, form]);

    

    const channelOptions = useMemo(() => {
        if(currentDomain){
            const domain = domains.find(item => item.domain === currentDomain);
            switch(platform){
                case 'bing':
                    return (domain?.bingChannels || []).map(item => ({ label: item, value: item }));
                case 'facebook':
                    return (domain?.fbChannels || []).map(item => ({ label: item, value: item }));
                case 'snap':
                    return (domain?.snapChannels || []).map(item => ({ label: item, value: item }));
                default:
                    return (domain?.channels || []).map(item => ({ label: item, value: item }));
                
            }
        }
        return [];
    }
    , [currentDomain, domains, platform]);


    return <Flex align="strench" vertical={true}  gap='middle'>
        <Form initialValues={formInitialValues} layout="inline" form={form}>
            <Flex style={{width: "100%"}} gap={5} wrap>
                <Form.Item style={{minWidth: 220}} label="币种" name="currencyCode" required={true} rules={[{ required: true, message: '货币不能为空' }]}>
                    <Select placeholder="币种" options={[
                        {value: 'USD', label: '美元'},
                        {value: 'HKD', label: '港币'},
                        {value: 'NGN', label: '尼日利亚奈拉'}
                    ]}></Select>
                </Form.Item>
                <Form.Item style={{minWidth: 300}} label="域名" name='labelUrl' required={true} rules={[{ required: true, message: '域名不能为空' }]}>
                    <Select  listHeight={400} filterOption={filter} allowClear={true} showSearch={true} placeholder="域名" options={useOldMapConvertToNew(domains, [['domain', 'label'], [ 'domain', 'value' ]])?.sort((a:any, b: any) => a?.label?.localeCompare(b?.label))} onChange={onSelect}></Select>
                </Form.Item>   
                <Form.Item style={{ minWidth: 180 }} label="渠道" name="channel">
                    <Select listHeight={400} filterOption={filter} allowClear={true} showSearch={true} placeholder="渠道" options={channelOptions}></Select>
                </Form.Item>
                <Form.Item style={{ minWidth: 200 }} label="日期" name="date">
                    <RangePicker maxDate={dayjs()} className="roi-filter" value={[dayjs().subtract(1, 'month'), dayjs()]}/>
                </Form.Item>
                <Form.Item style={{ minWidth: 250 }} label="国家" name="country" >
                    <Select listHeight={350} className="roi-filter" placeholder="国家" options={countries} showSearch={true} filterOption={filter} allowClear={true}  />
                </Form.Item>
                {platform === 'facebook' && (
                    <Form.Item style={{ minWidth: 250 }} label="收入" name="isShowOnlyIncome" >
                        <Select listHeight={350} className="roi-filter" placeholder="是否显示收入" options={IncomeOptions} showSearch={true} filterOption={filter} allowClear={true}  />
                    </Form.Item>
                )}
            </Flex>
        </Form>
        <Flex justify="space-between" gap={20}>
            <Flex justify="center" gap={40}>
                <Space align="center">
                    <Text style={{ fontSize: 28 }}>总花费:</Text>
                    <Text style={{ fontSize: 28 }}>{data?.sumHkdAdsCostMicros || 0}</Text>
                </Space>
                <Space align="center">
                    <Text style={{ fontSize: 28 }}>总收入:</Text>
                    <Text style={{ fontSize: 28 }}>{data?.sumRevenue || '0'}</Text>
                </Space>
                <Space align="center">
                    <Text style={{ fontSize: 28 }}>总ROI:</Text>
                    <Text style={{ fontSize: 28 }}>{data?.sumHkdRoiStr || '0.00%'}</Text>
                </Space>
            </Flex>
            <Space>
                <Button type="primary" loading={isLoading && (!isSuccess || !isError)} onClick={query}>查询</Button>
                <Button style={{backgroundColor: '#17a2b8', color: '#fff'}} onClick={exportHandler}>导出</Button>
            </Space>
            <Space>
                <Dropdown overlayStyle={{marginRight: '0'}} trigger={['click']} dropdownRender={(menus) => (
                    <ConfigProvider theme={{
                        token: {
                            controlHeight: 28
                        }
                    }}>
                        <Form style={{background: token.colorBgElevated, borderRadius: token.borderRadiusSM, boxShadow: token.boxShadowSecondary, padding: token.paddingContentVertical}} layout="vertical" onFieldsChange={onColumnChange}>
                            {
                                columnConfig.map((item, key) => {
                                    const localCacheStr = localStorage.getItem('columnCache');
                                    const localCache = localCacheStr && JSON.parse(localCacheStr) || [];
                                    const switchKey = item.dataIndex as string;
                                    const isChecked = localCache.length ? localCache.includes(switchKey) : true;
                                    const identifier = switchKey ?? item.key;
                                    return  <Form.Item style={{ marginBottom: 0, height: 28 }} initialValue={isChecked} key={identifier} valuePropName={'checked'} name={identifier}>
                                        <Checkbox>
                                            {item.title as string}
                                        </Checkbox>
                                    </Form.Item>
                                })
                            }
                        </Form> 
                    </ConfigProvider>
                ) }>
                    <Button icon={<UnorderedListOutlined />} shape="round"></Button>
                </Dropdown>
            </Space>
        </Flex>
    </Flex>
}




function RoiBoard({ userData, platform, tableData, findRoiStatus } : { userData: UserData, platform: string, tableData: any, findRoiStatus: { isLoading: boolean, isSuccess: boolean, isError: boolean } }) {
    const localCache = localStorage.getItem('columnCache');
    const columnConfig = columnConfigFN(platform);
    const defaultColumn = columnConfig.map(item => item.dataIndex as string);
    const showColumn = localCache && JSON.parse(localCache) || defaultColumn || [];
    // 动态显隐表格列
    const [columnFields, setColumnFields] = useState(showColumn);
    // 动态设置表格宽度
    const [tableWidth, setTableWidth] = useState(columnConfig.reduce((prev, current: ColumnConfigItemType) => prev + (columnFields.includes(current.dataIndex) ? current.width as number : 0), 0));

    const searchInput = useRef<InputRef>(null);
    const tableRef = useRef<TableRef>(null);

    // * 搜索
    const handleSearch = (
        selectedKeys: string[],
        confirm: () => void,
        dataIndex: string
    ) => {
        confirm();
    }
    // * 重置搜索
    const handleReset = (clearFilters: () => void, confirm: () => void) => {
        clearFilters();
        confirm();
    }

    const getColumnSearchProps = (dataIndex: any): TableColumnType<any> => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
            <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
                <Input
                ref={searchInput}
                placeholder={`Search ${dataIndex}`}
                value={selectedKeys[0]}
                onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                onPressEnter={() => handleSearch(selectedKeys as string[], confirm, dataIndex)}
                style={{ marginBottom: 8, display: 'block' }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() => handleSearch(selectedKeys as string[], confirm, dataIndex)}
                        icon={<SearchOutlined />}
                        size="small"
                        style={{ width: 90 }}
                    >
                        Search
                    </Button>
                    <Button
                        onClick={() => clearFilters && handleReset(clearFilters, confirm)}
                        size="small"
                        style={{ width: 90 }}
                    >
                        Reset
                    </Button>
                </Space>
            </div>
            ),
        filterIcon: (filtered: boolean) => {
            return <SearchOutlined style={{ color: filtered ? 'red' : undefined }} />
        },
        onFilter: (value, record) =>
            record[dataIndex]
                .toString()
                .toLowerCase()
                .includes((value as string).toLowerCase()),
        onFilterDropdownOpenChange: (visible) => {
            if (visible) {
                setTimeout(() => searchInput.current?.select(), 100);
            }
        }
    });


    const columnConfigFiltered = useMemo(
        () => {
            const tableWidth = columnConfig.reduce((prev, current: ColumnConfigItemType) => {
                return prev + (columnFields.includes(current.dataIndex) ? current.width as number : 0);
            }, 0);  
            setTableWidth(tableWidth);
            columnConfig.forEach((item: any) => {
                if(item?.canSearch){
                    const columnFielters = getColumnSearchProps(item.dataIndex);
                    item = Object.assign(item, columnFielters);
                }
            });
            return  columnConfig.map(
                col => {
                    // 为表格内容单元格设置特定类名 -- 用于样式控制 -- 用于onselectionchange事件触发的样式控制
                    col.onCell = (record: any, dataIndex) => {
                        return {
                            className: 'td-value'
                        }
                    }
                    const render = col.render;
                    if(!render){
                        col.render = (text: any, record: any) => {
                            return <span>{text}</span>
                        }
                    }
                    if(columnFields.includes(col.dataIndex)){
                        col.hidden = false;
                        return col;
                    }else{
                        col.hidden = true;
                        return col;
                    }
                }
            )
        }, 
        [columnFields]
    );

    const selectionChange = () => {
        const tableElement = tableRef.current?.nativeElement;
        const activeElement = tableElement?.getElementsByClassName('selection')[0];
        const selection: any = window.getSelection();
        const anchorNode = selection?.anchorNode?.parentElement;
        if(anchorNode?.tagName === 'SPAN' && anchorNode.parentElement?.classList.contains('td-value') && !selection?.isCollapsed && selection?.anchorNode?.textContent === selection?.baseNode?.textContent){
            if(activeElement){

                activeElement.innerHTML = activeElement.textContent as string;
                activeElement.classList.remove('selection');
            }
            const selectionString = selection?.toString();
            console.info('%c' + selectionString,'background: green;')
            console.info('%c' + anchorNode.textContent, 'background: red;',)
            if(selectionString){
                anchorNode.classList.add('selection');
                anchorNode.innerHTML = anchorNode.textContent.replace(selectionString.trim(), `<span>${selectionString.trim()}</span>`);
            }
        }
    }

    const { run : debounceHandler} = useDebounceFn(selectionChange, { wait: 300 })
    useEffect(() => {
        document.addEventListener('selectionchange', debounceHandler);
        return () => {
            document.removeEventListener('selectionchange', debounceHandler);
        }   
    }, [debounceHandler])

    //  virtual={true}
    return <Flex vertical={true} gap={20}>
        <RoiBoardHeader findRoiStatus={findRoiStatus}  userData={userData} platform={platform} setColumnFields={setColumnFields} data={tableData}></RoiBoardHeader>
        <Table ref={tableRef} loading={findRoiStatus.isLoading} size="middle" rowHoverable={false} bordered={true} columns={ columnConfigFiltered } dataSource={tableData?.resultDatas} sticky={{ offsetHeader: 0, offsetScroll: 0 }} scroll={{ x: tableWidth }}  pagination={{ defaultPageSize: 500, pageSizeOptions: [100, 200, 500, 1000], position: ["bottomRight"] }}></Table>
    </Flex>
}


export default function Roi() {
    const { userData } = useTypedSelector(state => state.authReducer);
    const { users, enableAutoQuery, refetch } = useTypedSelector(state => state.roiReducer);
    const dispatch = useTypedDispatch();
    // 切换用户请求参数
    const [ selectUserParams, setSelectUserParams ] = useState<SelectUserParams>();
    // 当前表格数据
    const [ tableData, setTableData] = useState<RoiData>();
    // 刷新按钮图标状态
    const [refreshUser, setRefreshUser] = useState<boolean>(false);
    // 是否重新请求User数据
    const [isRefetch, setIsRefetch] = useState<string>();

    // * 参数
    const { platForms, subUsers, id, atn } = userData as UserData;
    const { platform } = users[atn] || { params: undefined, platform: undefined };
    let params : FindRoiParams;
    switch(platform){
        case 'bing':
            params = users[atn]?.bingparams;
            break;
        case 'facebook':
            params = users[atn]?.facebookparams;
            break;
        case 'snap':
            params = users[atn]?.snapparams;
            break;
        default:
            params = users[atn]?.googleparams;
            break;
    }
    

    // * 选择用户请求逻辑
    const { data: currentUser } = useQuery({
        queryKey: ['selectUser', selectUserParams, isRefetch],
        queryFn: () => selectUser(selectUserParams!),
        enabled: !!selectUserParams,
    });
    useEffect(() => {
        if(currentUser && (JSON.stringify(currentUser) !== JSON.stringify(userData))){
            dispatch({ type: 'auth/setUserData', payload: currentUser});
        }
        setRefreshUser(false);
    }, [currentUser, userData, dispatch]);

    // * 获取roi数据请求逻辑
    const { data, isLoading, isSuccess, isError } = useQuery({
        queryKey: ['roi', params, platform, refetch],
        queryFn: () => findRoi(params, platform),
        enabled: !!params && !!platform && enableAutoQuery,
        refetchOnWindowFocus: false
    }); 

    useEffect(() => {
        if(typeof data === 'undefined'){
            return () => {};
        }
        data.resultDatas = (data.resultDatas || []).map((item,key) => {
            item['key'] = `${item.subAccountId}-${item.queryDate}-${item.labelUrl}-${item.country}-${item.camName}`;
            return item;
        })
        setTableData(data);
        return () => {};
    }, [data])

    // * 标签页切换
    const tabProps = useMemo(() => {
        return platForms.map((item) => {
            return {
                label: item,
                key: item,
                children: <RoiBoard findRoiStatus={{isLoading, isSuccess, isError}} platform={item} userData={userData as UserData} tableData={tableData} />
            }
        });
    }, [platForms, isLoading, isSuccess, isError, userData, tableData]);
    // * 切换账号
    const changeAccount = (value: string) => {
         setSelectUserParams({ id: id, selectId: value});
    }
        
    // * 打开模态框
    const openModal = () => {
        dispatch({ type: 'modal/showModal', payload: { type: MODAL_TYPE[platform as keyof typeof MODAL_TYPE], status: true, data: {} }  });
    }
    
    // * 弹出全体变现数据查询模态框
    const getData = () => {
        dispatch({ type: 'modal/showModal', payload: { type: MODAL_TYPE.all, status: true, data: {} } })
    }

    // * 标签页切换事件 - 更新用户查询参数中的平台参数
    const handleTabChange = (key: string) => {
        let params!: FindRoiParams;
        switch(key){
            case 'snap':
                params = users[atn]?.snapparams;
                break;
            case 'facebook':
                params = users[atn]?.facebookparams;
                break;
            case 'bing':
                params = users[atn]?.bingparams;
                break;
            default:
                params = users[atn]?.googleparams;
                break;
        }
        dispatch({ type: 'roi/setUserQuery', payload: { atn: atn, value: { platform: key, params }}});
    }

    // * 刷新用户数据
    const handleRefresh = () => {
        if(!selectUserParams){
            setSelectUserParams({ id, selectId: atn})
        }
        setRefreshUser(true);
        setIsRefetch(uuidv4());
        console.info(selectUserParams, refreshUser);
    }

    const platformHandle = (platform: string) => {
        return platForms.includes(platform) ? platform : 'google';
    }

    return  <ConfigProvider locale={zhCN} theme={{
                token: {
                    fontSize: 16,
                    paddingSM: 16,
                    controlHeight: 40
                },
                components: {
                    Table: {
                        headerBg: '#f6ffed',
                        headerColor: '#52c41a',
                        headerSortHoverBg: '#d9f7be',
                        headerSortActiveBg: '#95de64'
                    },
                    Tabs: {
                        titleFontSizeLG: 28
                    }
                }
            }}>  
                <Flex vertical={true} gap={16}>
                    <Tabs tabBarExtraContent={
                        {
                            left : <Space className="header" size={15} align="center">
                                <Space>
                                    <p>当前账号:</p>
                                    <Select listHeight={500} style={{ minWidth: '260px' }} onChange={changeAccount} placeholder="账号" options={useOldMapConvertToNew(subUsers, [['id', 'value'], ['userName', 'label']])} defaultValue={atn} ></Select>
                                </Space>
                                <Button style={{backgroundColor: '#ffc107'}} onClick={openModal}>获取买量全天数据</Button>
                                <Button type="primary" onClick={getData}> 获取全天变现数据 </Button>
                                <Tooltip title="刷新用户数据">
                                    <Button onClick={handleRefresh} icon={<ReloadOutlined spin={refreshUser} />}></Button>
                                </Tooltip>
                            </Space>
                        }
                    } centered size="large" onChange={handleTabChange} activeKey={platformHandle(platform)} items={tabProps} ></Tabs>
                    <GoogleModal></GoogleModal>
                    <SnapModal></SnapModal>
                    <FacebookModal></FacebookModal>
                    <BingModal></BingModal>
                    <AllModal></AllModal>
                </Flex> 
            </ConfigProvider>
}